











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class MenuTab extends Vue {
  @Prop({ required: true }) objectText: string
  created() {
    alert(this.objectText)
  }
}
